export const getAdminHeaderOpenState = state => state.admin.headerIsOpen;
